import { observer } from "mobx-react-lite";

import { Link } from "react-router-dom";
// import CardActions from '@mui/joy/CardActions';
//import Button from '@mui/joy/Button';
//import Divider from '@mui/joy/Divider';

import Stack from '@mui/joy/Stack';
import Tooltip from '@mui/joy/Tooltip';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import Button from "@mui/joy/Button";
// import CopyFancyHandsBullets from "./CopyFancyHandsBullets";
import CardLoggedOut from './CardLoggedOut';

import useAuth from 'hooks/useAuth';
import { getIcon } from 'utils/misc';


const HomeLoggedOut = observer(() => {
    const { checkingAuth } = useAuth();
    const LoadingIcon = getIcon('Replay');
    const LoginIcon = getIcon('KeyOutlined');
    const LearnMoreIcon = getIcon('TipsAndUpdatesOutlined');
    //    const navigate = useNavigate();


    return (
        <CardLoggedOut>

            {checkingAuth &&
                <Stack
                    p={2}
                    justifyItems="center"
                    alignItems="center">
                    <Typography
                        endDecorator={<LoadingIcon
                                          className="slowspin"
                                          color="primary"
                        />}
                        level="body-sm">
                        Checking to see if you're logged in.
                    </Typography>
                </Stack>
            }

            <Sheet sx={{ m: 1, borderColor: "", borderRadius: 7 }}>
                <Stack spacing={1} p={2} justifyItems="center" alignItems="center">

                    {/*
                <Typography level="title-sm" mb={1}>
                    A brand new thing by the ones from the good old days
                    </Typography>
                  */}


                    <Stack spacing={2}>
                        <Stack alignItems="center" spacing={1}>

                            <Stack
                                pb={1}
                                alignItems="center">
                                <Tooltip
                                    title="You should try this out, but you may find some bugs.">
                                    <Typography level="title-lg" >
                                        Now in
                                        <Typography
                                            ml={0.5}
                                            color="warning"
                                            variant="soft"
                                            level="title-lg" >
                                            beta
                                        </Typography>
                                    </Typography>
                                </Tooltip>
                                <Typography level="title-sm" >
                                    Why don't you click around?
                                </Typography>
                            </Stack>
                            <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                            >



                                <Tooltip arrow
                                    title="Learn more about what we're doing.">
                                    <Link to="/welcome">
                                        <Button
                                            endDecorator={<LearnMoreIcon />}
                                            variant="solid">
                                            Learn More
                                        </Button>
                                    </Link>
                                </Tooltip>

                                <Tooltip arrow
                                    title="Log in or update your password.">
                                    <Link to="/login">
                                        <Button
                                            endDecorator={<LoginIcon />}
                                            variant="outlined">
                                            Log In
                                        </Button>
                                    </Link>
                                </Tooltip>

                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>
            </Sheet>



            {/*
                        <CopyFancyHandsBullets />
                <Divider>Now is the time</Divider>

            <CardActions buttonFlex="1 1">
                <Button variant="outlined" color="neutral"  onClick={() => navigate('/login') }>
                    Log In
                </Button>

                <Button variant="solid" color="primary" disabled>
                    Sign Up
                </Button>
                    </CardActions>
              */}
        </CardLoggedOut>

    );
});
export default HomeLoggedOut;
